import ProfileModal from '@features/games/profile/profile-modal/profile-modal';
export default ProfileModal;
